import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ClassificacaoFaturamentoMultiselectComponent } from './classificacao-faturamento-multiselect.component';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        ClassificacaoFaturamentoMultiselectComponent
    ],
    exports: [
        ClassificacaoFaturamentoMultiselectComponent
    ]
})
export class ClassificacaoFaturamentoMultiselectModule { }
